"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.viewSF = void 0;
function viewSF() {
    var _this = this;
    return {
        constructor: function (props) {
            _this.state = {
                isChecked: props.isChecked,
                errorMessage: props.errorMessage
            };
        },
        willReceiveProps: function (nextProps) {
            if (_this.props.isChecked !== nextProps.isChecked) {
                _this.setState({
                    isChecked: nextProps.isChecked
                });
            }
            if (_this.props.errorMessage !== nextProps.errorMessage) {
                _this.setState({
                    errorMessage: nextProps.errorMessage
                });
            }
        },
        events: {
            onChange: function (isChecked, id) {
                _this.setState({
                    isChecked: isChecked,
                    errorMessage: ''
                });
                _this.props.onChange(isChecked, id);
            }
        }
    };
}
exports.viewSF = viewSF;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/CheckboxStateWrapper/ViewSF.js
// module id = 334
// module chunks = 0 1